(() => {
  'use strict';
  if (window.AWGarageExactModelAssistant?.version) return;

  const normalize = (value = '') => String(value || '').trim().toLowerCase().normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '').replace(/&/g, ' et ').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  const readJson = (key, fallback) => {
    try { return JSON.parse(localStorage.getItem(key) || 'null') ?? fallback; }
    catch (_) { return fallback; }
  };
  const readReplicas = () => {
    const value = readJson('aw_garage_replicas_v1', []);
    return Array.isArray(value) ? value : [];
  };
  const nodes = () => Array.from(document.querySelectorAll('[data-aw-model-context-model],[data-aw-tool-model]'));
  const record = (node) => node ? ({
    handle: String(node.dataset.handle || '').trim(),
    label: String(node.dataset.label || '').trim(),
    model: String(node.dataset.model || '').trim(),
    manufacturer: String(node.dataset.manufacturer || '').trim(),
    platform: String(node.dataset.platform || '').trim(),
    platformLabel: String(node.dataset.platformLabel || node.dataset.platform || '').trim(),
    type: String(node.dataset.type || '').trim(),
    pageUrl: String(node.dataset.pageUrl || '').trim(),
    workshopServices: String(node.dataset.workshopServices || '').split(',').map((x) => x.trim()).filter(Boolean)
  }) : null;
  const records = () => {
    const map = new Map();
    nodes().map(record).filter((item) => item?.handle && item.model).forEach((item) => map.set(item.handle, item));
    return [...map.values()];
  };
  const resolve = (value, manufacturer = '', platform = '', type = '') => {
    const needle = normalize(value);
    if (!needle) return null;
    const maker = normalize(manufacturer);
    const p = normalize(platform);
    const t = normalize(type);
    const matches = records().filter((item) => {
      if (maker && normalize(item.manufacturer) !== maker) return false;
      if (p && normalize(item.platform) !== p && normalize(item.platformLabel) !== p) return false;
      if (t && normalize(item.type) !== t) return false;
      return [item.handle, item.label, item.model, `${item.manufacturer} ${item.model}`].some((candidate) => normalize(candidate) === needle);
    });
    return matches.length === 1 ? matches[0] : null;
  };
  const resolveReplica = (replica) => window.AWEcosystemP1Bridge?.resolveExactModel?.(replica)
    || resolve(replica?.model || '', replica?.manufacturer || '', replica?.platform || '', replica?.type || '');
  const compatibilityExact = () => {
    const bridgeExact = window.AWModelContextBridge?.currentExact?.();
    const storedExact = readJson('aw_exact_model_context_v1', {});
    const shared = readJson('aw_airsoft_context_v1', {});
    const handle = String(bridgeExact?.handle || storedExact?.handle || shared?.modelHandle || '').trim();
    if (handle) {
      const found = records().find((item) => item.handle === handle);
      if (found) return found;
    }
    const model = bridgeExact?.model || storedExact?.model || shared?.model || shared?.modelLabel || '';
    const manufacturer = bridgeExact?.manufacturer || storedExact?.manufacturer || shared?.manufacturer || shared?.manufacturerLabel || '';
    const platform = bridgeExact?.platform || storedExact?.platform || shared?.platform || '';
    const type = bridgeExact?.type || storedExact?.type || shared?.type || '';
    return resolve(model, manufacturer, platform, type) || resolve(model, manufacturer) || null;
  };
  const fillForm = (form, found, status) => {
    if (!form || !found) return false;
    const model = form.elements.model;
    const manufacturer = form.elements.manufacturer;
    const platform = form.elements.platform;
    const type = form.elements.replica_type;
    if (!model || !manufacturer || !platform || !type) return false;
    manufacturer.value = found.manufacturer;
    model.value = found.model;
    platform.value = found.platformLabel || found.platform;
    type.value = found.type;
    form.dataset.awExactModelHandle = found.handle;
    [manufacturer, model, platform, type].forEach((field) => {
      field.dispatchEvent(new Event('input', { bubbles: true }));
      field.dispatchEvent(new Event('change', { bubbles: true }));
    });
    if (status) status.textContent = `Prérempli depuis Compatibility AW : ${found.label || `${found.manufacturer} ${found.model}`}. Vérifiez les informations puis enregistrez vous-même la fiche Garage.`;
    return true;
  };

  const syncPrefillButton = (form) => {
    const button = form?.querySelector?.('[data-aw-garage-prefill-exact]');
    if (!button) return;
    const found = compatibilityExact();
    button.hidden = !found;
    if (found) {
      button.dataset.modelHandle = found.handle;
      button.textContent = `Préremplir avec ${found.label || `${found.manufacturer} ${found.model}`}`;
    } else {
      delete button.dataset.modelHandle;
    }
  };

  const initForm = (root) => {
    const form = root.querySelector('[data-aw-garage-replica-form]');
    if (!form) return;
    if (form.dataset.awExactAssistant === 'true') {
      syncPrefillButton(form);
      return;
    }
    form.dataset.awExactAssistant = 'true';
    const model = form.elements.model;
    const manufacturer = form.elements.manufacturer;
    const platform = form.elements.platform;
    const type = form.elements.replica_type;
    if (!model || !manufacturer || !platform || !type) return;

    const listId = `aw-garage-models-${Math.random().toString(36).slice(2, 8)}`;
    const datalist = document.createElement('datalist');
    datalist.id = listId;
    form.append(datalist);
    model.setAttribute('list', listId);
    model.setAttribute('autocomplete', 'off');

    const status = document.createElement('p');
    status.dataset.awGarageExactStatus = 'true';
    status.className = 'aw-p2-note';
    status.textContent = 'Modèle libre : vous pouvez saisir votre équipement manuellement ou choisir une proposition de la base Compatibility AW.';
    model.closest('label')?.insertAdjacentElement('afterend', status);

    const prefill = document.createElement('button');
    prefill.type = 'button';
    prefill.className = 'button button--secondary';
    prefill.dataset.awGaragePrefillExact = 'true';
    prefill.hidden = true;
    status.insertAdjacentElement('afterend', prefill);
    prefill.addEventListener('click', () => {
      const found = compatibilityExact();
      if (found) fillForm(form, found, status);
    });

    const refreshList = () => {
      datalist.replaceChildren();
      records().forEach((item) => {
        const option = document.createElement('option');
        option.value = item.label || `${item.manufacturer} ${item.model}`.trim();
        option.label = [item.platformLabel, item.type].filter(Boolean).join(' · ');
        datalist.append(option);
      });
      syncPrefillButton(form);
    };

    let timer = 0;
    const apply = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        const found = resolve(model.value, manufacturer.value, platform.value, type.value)
          || resolve(model.value, manufacturer.value)
          || resolve(model.value);
        if (!found) {
          delete form.dataset.awExactModelHandle;
          status.textContent = model.value
            ? 'Raccordement exact AW non confirmé : les valeurs saisies restent utilisables dans le Garage, sans être présentées comme un modèle Compatibility exact.'
            : 'Modèle libre : vous pouvez saisir votre équipement manuellement ou choisir une proposition de la base Compatibility AW.';
          return;
        }
        manufacturer.value = found.manufacturer;
        model.value = found.model;
        platform.value = found.platformLabel || found.platform;
        type.value = found.type;
        form.dataset.awExactModelHandle = found.handle;
        status.textContent = `Modèle exact AW reconnu : ${found.label || `${found.manufacturer} ${found.model}`} · ${found.platformLabel || found.platform || 'plateforme à confirmer'} · ${found.type || 'type à confirmer'}${found.workshopServices.length ? ` · ${found.workshopServices.length} relation${found.workshopServices.length > 1 ? 's' : ''} Atelier exacte${found.workshopServices.length > 1 ? 's' : ''}` : ' · aucune relation Atelier exacte enregistrée'}.`;
      }, 20);
    };
    ['input', 'change'].forEach((name) => model.addEventListener(name, apply));
    [manufacturer, platform, type].forEach((field) => field.addEventListener('change', apply));
    root.addEventListener('click', (event) => {
      if (!event.target.closest?.('[data-aw-replica-edit]')) return;
      setTimeout(apply, 30);
    });
    window.addEventListener('aw:model-index-ready', refreshList);
    refreshList();
  };

  const decorateCards = (root) => {
    const replicas = readReplicas();
    root.querySelectorAll('[data-replica-id]').forEach((card) => {
      const id = String(card.dataset.replicaId || '');
      const replica = replicas.find((item) => String(item?.id || '') === id);
      if (!replica) return;
      let note = card.querySelector('[data-aw-garage-model-status]');
      if (!note) {
        note = document.createElement('p');
        note.dataset.awGarageModelStatus = 'true';
        note.className = 'aw-p2-note';
        card.querySelector('.aw-p2-card__actions')?.before(note);
      }
      const found = resolveReplica(replica);
      if (found) {
        const serviceCount = found.workshopServices.length;
        note.dataset.status = 'exact';
        note.textContent = `Compatibility AW : modèle exact reconnu · ${found.label || `${found.manufacturer} ${found.model}`}${serviceCount ? ` · ${serviceCount} relation${serviceCount > 1 ? 's' : ''} Atelier exacte${serviceCount > 1 ? 's' : ''}` : ' · aucune relation Atelier exacte enregistrée'}.`;
      } else {
        note.dataset.status = 'unresolved';
        note.textContent = replica.model
          ? 'Compatibility AW : modèle exact non confirmé. Les actions proposées restent contextuelles et doivent être vérifiées avant achat ou intervention.'
          : 'Compatibility AW : aucun modèle exact renseigné pour cette fiche Garage.';
      }
    });
  };

  let scheduled = false;
  const render = () => {
    if (scheduled) return;
    scheduled = true;
    setTimeout(() => {
      scheduled = false;
      document.querySelectorAll('[data-aw-garage-p2]').forEach((root) => {
        initForm(root);
        decorateCards(root);
      });
    }, 40);
  };
  ['aw:model-index-ready', 'aw:p2-garage-updated', 'aw:garage-context-changed', 'aw:context-changed', 'aw:project-model-mapped'].forEach((name) => window.addEventListener(name, render));
  window.addEventListener('storage', (event) => { if (['aw_garage_replicas_v1','aw_airsoft_context_v1','aw_exact_model_context_v1'].includes(event.key)) render(); });
  document.addEventListener('shopify:section:load', render);

  window.AWGarageExactModelAssistant = { version: '1.1.0', render, resolve, records, compatibilityExact, policy: 'assist-only;explicit-prefill-only;never-invent-exact-model' };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', render, { once: true });
  else render();
})();
